module.exports = __webpack_public_path__ + "img/quad-temperature-sm.a735e41f.svg";